<template>
  <div>
    <!--    {{leadNotes}}-->
    <div class="tabsNotes">
      <!--      {{note}}-->
      <div class="dates-wrap">
<!--        <h5 class="dates">November, 2024</h5>-->
        <h5 class="dates"></h5>
        <!-- <div class="create-note">
          <button class="btn" @click="addCommnetToSupport" :data-id="$route.params.id">Add Note</button>
        </div> -->
      </div>
      <div class="accordion-wrap">
        <div v-for="(note, index) in leadNotes" :key="note.id">
          <div :id="'accordion' + index">
            <div class="card mb-3">
              <div class="card-header" :id="'headingThree' + index">
                <h5 class="mb-0">
                  <div class="accordion-header">
                    <button
                        class="btn btn-link collapsed"
                        @click="toggleAccordion(index)"
                        :aria-expanded="activeIndex === index"
                        :aria-controls="'collapseThree' + index"
                    >
                      <div class="container-fluid accordion-button-content">
                        <div class="accordion-heading-wrap">
                          <div class="accordion-arrow-wrap">
                            <h5 class="accordion-heading">
                              <i :class="activeIndex === index ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="accordion-arrow"></i>
                              <b>{{ note.user.first_name }} {{ note.user.last_name }}</b> added note
                            </h5>
                            <h5 class="accordion-para" :class="{ 'd-none': activeIndex === index }" v-html="note.comment && note.comment.length > 100 ? `${note.comment.substring(0, 150)}...` : note.comment"></h5>
                          </div>
                          <div class="accordion-time-wrap">
                            <div class="accordion-time">
                              <h5 class="time-span">{{ note.created_at }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div
                      :id="'collapseThree' + index"
                      class="collapse"
                      :class="{ show: activeIndex === index }"
                      :aria-labelledby="'collapseThree' + index"
                      :data-parent="'#accordion' + index"
                  >
                    <div class="card-body pl-3" v-html="note.comment"></div>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="tabsNotes">-->
    <!--      <div class="dates-wrap">-->
    <!--        <h5 class="dates">December, 2024</h5>-->
    <!--        <div class="create-note"></div>-->
    <!--      </div>-->
    <!--      <div class="accordion-wrap">-->
    <!--        <div id="accordion">-->
    <!--          <div class="card mb-3">-->
    <!--            <div class="card-header" id="headingFour">-->
    <!--              <h5 class="mb-0">-->
    <!--                <div class="accordion-header">-->
    <!--                  <button-->
    <!--                    class="btn btn-link collapsed"-->
    <!--                    data-toggle="collapse"-->
    <!--                    data-target="#collapseFour"-->
    <!--                    aria-expanded="true"-->
    <!--                    aria-controls="collapseFour"-->
    <!--                  >-->
    <!--                    <div class="container-fluid accordion-button-content">-->
    <!--                      <div class="accordion-heading-wrap">-->
    <!--                        <div class="accordion-arrow-wrap">-->
    <!--                          <h5 class="accordion-heading">-->
    <!--                            <i class="fas fa-chevron-right accordion-arrow"></i>-->
    <!--                            How does writing influence your personal brand?-->
    <!--                          </h5>-->
    <!--                          <h5 class="accordion-heading1">Meeting Purpose</h5>-->
    <!--                          <h5 class="accordion-para">-->
    <!--                            Demonstrate LinenTech software capabilities to-->
    <!--                            Joseph Kendziuk for potential implementation in his-->
    <!--                            linen business.-->
    <!--                          </h5>-->
    <!--                        </div>-->
    <!--                        <div class="accordion-time-wrap">-->
    <!--                          <div class="accordion-time">-->
    <!--                            <h5 class="time-span">19 September, 2024</h5>-->
    <!--                            <h5 class="time-span">04:23 PM GMT</h5>-->
    <!--                          </div>-->
    <!--                        </div>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </button>-->
    <!--                  <button-->
    <!--                    class="accordion-menu"-->
    <!--                    @click="toggleMenu('headingFour')"-->
    <!--                    :class="{-->
    <!--                      activeMenu: activeMenuId === 'headingFour',-->
    <!--                    }"-->
    <!--                  >-->
    <!--                    <i class="fas fa-ellipsis-h"></i>-->
    <!--                    <div class="accordionDropdown">-->
    <!--                      <div class="accordionDropdownWrapper">-->
    <!--                        <button class="editDeleteBtn">-->
    <!--                          <img :src="editIcon" alt="" /> Edit-->
    <!--                        </button>-->
    <!--                        <button class="editDeleteBtn">-->
    <!--                          <img :src="deleteIcon" alt="" /> Delete-->
    <!--                        </button>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </button>-->
    <!--                </div>-->
    <!--                <div-->
    <!--                  id="collapseFour"-->
    <!--                  class="collapse"-->
    <!--                  aria-labelledby="headingFour"-->
    <!--                  data-parent="#accordion"-->
    <!--                >-->
    <!--                  <div class="card-body">-->
    <!--                    <h5 class="card-heading">Meeting Purpose</h5>-->
    <!--                    <p class="card-para">-->
    <!--                      Demonstrate LinenTech software capabilities to Joseph-->
    <!--                      Kendziuk for potential implementation in his linen-->
    <!--                      business.-->
    <!--                    </p>-->
    <!--                    <h5 class="card-heading">Key Takeaways</h5>-->
    <!--                    <ul class="card-list">-->
    <!--                      <li>-->
    <!--                        Joseph's business: ~95% hospitality clients, 2 routes,-->
    <!--                        ~650 customers serviced bi-weekly-->
    <!--                      </li>-->
    <!--                      <li>-->
    <!--                        Joseph's business: ~95% hospitality clients, 2 routes,-->
    <!--                        ~650 customers serviced bi-weekly-->
    <!--                      </li>-->
    <!--                      <li>-->
    <!--                        Joseph's business: ~95% hospitality clients, 2 routes,-->
    <!--                        ~650 customers serviced bi-weekly-->
    <!--                      </li>-->
    <!--                      <li>-->
    <!--                        Joseph's business: ~95% hospitality clients, 2 routes,-->
    <!--                        ~650 customers serviced bi-weekly-->
    <!--                      </li>-->
    <!--                    </ul>-->
    <!--                    <h5 class="card-heading">Topics</h5>-->
    <!--                    <h5 class="card-heading">Current Business Operations</h5>-->
    <!--                    <ul class="card-list">-->
    <!--                      <li>95% hospitality clients, 5% takeaway/box orders</li>-->
    <!--                    </ul>-->
    <!--                  </div>-->
    <!--                  <div class="notesButtonWrapper">-->
    <!--                    <button class="addEditNotes addButtonNotes">-->
    <!--                      <i class="fas fa-plus"></i>-->
    <!--                    </button>-->
    <!--                    <button class="addEditNotes editButtonNotes">-->
    <!--                      <img :src="pencilEdit" alt="" />-->
    <!--                    </button>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </h5>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import pencilEdit from "@/assets/images/pencil-edit.svg";
import editIcon from "@/assets/images/edit2.svg";
import deleteIcon from "@/assets/images/delete.svg";
import {flatMap} from "lodash/collection";
import supportComment from "@/components/support/support_comment.vue";

export default {
  name: "NotesTab",
  props: {
    showCreateNote: {
      type: Function,
      required: true,
    },
    leadNotes: [],
    customerDetail: []
  },
  data() {
    return {
      activeMenuId: null,
      deleteIcon: deleteIcon,
      editIcon: editIcon,
      pencilEdit: pencilEdit,
      activeIndex: null,
    };
  },

  mounted() {

  },

  methods: {

    toggleAccordion(index) {
      // If the same accordion is clicked, collapse it; otherwise, expand the clicked one
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    flatMap,
    toggleMenu(menuId) {
      this.activeMenuId = this.activeMenuId === menuId ? null : menuId;
    },

    addCommnetToSupport(event) {
      this.$store.dispatch("modal/update", {
        action: "add_comment_for_support_ticket",
        title: `Title: ${this.customerDetail.company}`,
        flag:false,
        formData: {
          lead_id: event.currentTarget.dataset.id,
          component: "lead-note"
        },
        component: supportComment,
      });
    },
  }
};


</script>
